import React from 'react';
import './info-banner.scss';
import CTAButton from '../CTAButton/CTAButton';

// TODO: Determine if infobar will only be used with scholarships and if the icons can be mapped to scholarship status.
import Eyes from '../SVG/Eyes';

export default ({ title = '', subtitle = '', ctaText = '',  Icon = Eyes, useCtaAction = true, ctaAction = () => {} }) => {

    return (
        <div id='info-banner'>
            <div id='info-banner__left'>
                {/* { Icon && <div id='info-banner__icon'><Icon /></div> } */}
                { title && <span className='H6DesktopWhite info-banner__text-item'>{ title }</span> }
                { title && subtitle && <span className='H6DesktopWhite info-banner__text-item'>—</span> }
                { subtitle && <span className='BodyLargeWhite info-banner__text-item'>{ subtitle }</span> }
            </div>
            <div id='info-banner__right'>

                { useCtaAction && ctaText &&
                    <CTAButton type='tertiary' outline arrow onClick={ctaAction}>
                        { ctaText }
                    </CTAButton>
                }

                { !useCtaAction && ctaText &&
                    <span className='H6DesktopWhite'>{ ctaText }</span>
                }
            </div>
        </div>
    );
};
